<template>
    <v-container fluid fill-height full-width class="pa-0">
        <v-card class="black--text"  color="white" width="100%">
            <v-toolbar color="amber" height="40px">
                <v-btn icon @click="Close()"> <v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title class="font-weight-black text-uppercase black--text">Order Id - {{orderRecord.id}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-chip label small color="black" text-color="amber" class="caption font-weight-bold text-uppercase"> Order Detail </v-chip>
            </v-toolbar>
            <v-card-text>
                <v-row class="ma-0">
                <v-col :md='orderRecord.status=="approved" ? 6 : 12' :sm='orderRecord.status=="approved" ? 6 : 12' cos=12 :class='orderRecord.status=="approved" ? "" : "ma-auto"'>
                    <v-card outlined="">
                        <v-simple-table dense>
                            <template v-slot:default>
                                <tbody class="caption" v-if="orderRecord.fRate !=null">
                                    <tr><td class="subtitle-1 font-weight-light py-1">Product</td><td class="subtitle-1 font-weight-light py-1">{{orderRecord.productName}}</td></tr>
                                    <!--<tr><td class="subtitle-1 font-weight-light py-1">Product Nature</td><td class="subtitle-1 font-weight-light py-1">{{orderRecord.productNature}}</td></tr>-->
                                    <tr><td class="subtitle-1 font-weight-light py-1">Order Type</td><td class="subtitle-1 font-weight-light py-1">{{orderRecord.orderType}}</td></tr>
                                    <tr><td class="subtitle-1 font-weight-light py-1">Order Condition</td><td class="subtitle-1 font-weight-light py-1">{{orderRecord.conditionType}}</td></tr>
                                    <tr><td class="subtitle-1 font-weight-light py-1">Qty</td><td class="subtitle-1 font-weight-light py-1">{{orderRecord.oQty}}</td></tr>
                                    <tr><td class="subtitle-1 font-weight-light py-1">Rate</td><td class="subtitle-1 font-weight-light py-1">{{orderRecord.oRate}}</td></tr>
                                    <tr><td class="subtitle-1 font-weight-light py-1">Demand Rate</td><td class="subtitle-1 font-weight-light py-1">{{orderRecord.dRate}}</td></tr>
                                    <tr><td class="subtitle-1 font-weight-light py-1">Location</td><td class="subtitle-1 font-weight-light py-1">{{orderRecord.location}}</td></tr>
                                    <tr v-if="orderRecord.freight == 'EX'"><td class="subtitle-1 font-weight-light py-1">Freight</td><td class="subtitle-1 font-weight-light py-1">{{orderRecord.freight}}</td></tr>
                                    <tr><td class="subtitle-1 font-weight-light py-1">Final Qty</td><td class="subtitle-1 font-weight-light py-1">{{orderRecord.fQty}}</td></tr>
                                    <tr><td class="subtitle-1 font-weight-light py-1">Final Rate</td><td class="subtitle-1 font-weight-light py-1">{{orderRecord.fRate}}</td></tr>
                                    <!--<tr><td class="subtitle-1 font-weight-light py-1">Final Loading Date</td><td class="subtitle-1 font-weight-light py-1">{{orderRecord.fLoadingDate}}</td></tr>-->
                                    <!--<tr><td class="subtitle-1 font-weight-light py-1">Final Payment Date</td><td class="subtitle-1 font-weight-light py-1">{{orderRecord.fPaymentDate}}</td></tr>-->
                                    <tr v-if="orderRecord.status == 'pending'"><td colspan=2>
                                            <v-row justify="space-around">
                                                <v-col cols="1">
                                                    <v-checkbox v-model="isAccept" color="amber" @change="TermBox=true;" class="ma-0"></v-checkbox>
                                                </v-col>
                                                <v-col cols="10">
                                                    <v-btn color="black" text class="ma-0" @click="TermBox=true;">Term and Conditions</v-btn>
                                                </v-col>
                                            </v-row>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody class="caption" v-else>
                                    <tr><td class="subtitle-1 font-weight-light py-1">Product</td><td class="subtitle-1 font-weight-light py-1">{{orderRecord.productName}}</td></tr>
                                    <!--<tr><td class="subtitle-1 font-weight-light py-1">Product Nature</td><td class="subtitle-1 font-weight-light py-1">{{orderRecord.productNature}}</td></tr>
                                    <tr><td class="subtitle-1 font-weight-light py-1">Order Type</td><td class="subtitle-1 font-weight-light py-1">{{orderRecord.orderType}}</td></tr>
                                    <tr><td class="subtitle-1 font-weight-light py-1">Order Condition</td><td class="subtitle-1 font-weight-light py-1">{{orderRecord.conditionType}}</td></tr>-->
                                    <tr><td class="subtitle-1 font-weight-light py-1">Demand Rate</td><td class="subtitle-1 font-weight-light py-1">{{orderRecord.dRate}}</td></tr>
                                    <tr>
                                        <td class="subtitle-1 font-weight-light py-1">Qty</td>
                                        <td class="subtitle-1 font-weight-light py-1">
                                            <v-text-field v-model="oQty" label="Qty / Tons" outlined color="amber" dense hide-details></v-text-field>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="subtitle-1 font-weight-light py-1">Rate</td>
                                        <td class="subtitle-1 font-weight-light py-1">
                                            <v-text-field v-model="oRate" label="Rate / Qtl" outlined color="amber" dense hide-details></v-text-field>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="subtitle-1 font-weight-light py-1">Location</td>
                                        <td class="subtitle-1 font-weight-light py-1">
                                            <v-text-field v-model="location" label="Location" outlined color="amber" dense hide-details></v-text-field>
                                        </td>
                                    </tr>
                                    <tr v-if="orderRecord.orderType =='EX'">
                                        <td class="subtitle-1 font-weight-light py-1">Freight</td>
                                        <td class="subtitle-1 font-weight-light py-1">
                                            <v-text-field v-model="freight" label="Freight Charges / Qtl" outlined color="amber" dense hide-details></v-text-field>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card>
                </v-col>
                <v-col v-if="orderRecord.status =='approved'" cols=12 md="6" sm=6>
                        <v-card color="white">
                            <v-toolbar color="white" flat min-height="auto">
                                <h2> PARTIES</h2>
                                <v-spacer></v-spacer>
                                <v-btn color="amber" @click="Send()">Send Email</v-btn>
                            </v-toolbar>
                            <v-card-text>
                                <v-row>
                                    <v-col sm=12 md=6 lg=6 cols=12>
                                        <v-autocomplete class="mt-4" label="Select Party" color="amber" item-text="name" item-value="id"
                                        outlined :items="partyData"  v-model="party" dense hide-details></v-autocomplete>
                                    </v-col>
                                    <v-col sm=12 md=6 lg=6 cols=12>
                                        <v-text-field class="mt-4" label="Assign Qty / Tons." color="amber" v-model="qty" outlined dense hide-details></v-text-field>
                                    </v-col>
                                    <v-col sm=12 md=6 lg=6 cols=12>
                                    <v-btn color="amber" :disabled="isAdd" @click="addParty()" :loading='loadingParty'>+ Add</v-btn>
                                    </v-col>
                                </v-row>
                                <v-data-table :headers="orderPartyHeader" :items="orderPartyData" :items-per-page="5" class="elevation-0"></v-data-table>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-col class="text-right"  v-if="orderRecord.status == 'pending'">
                    <v-btn  :loading="loading" v-if="orderRecord.fRate == null || orderRecord.fRate == ''" color="amber" class="black--text" @click="Save()">Save</v-btn>
                    <v-btn :loading="loading" v-else color="amber" :disabled="isDisabled" class="black--text" @click="Approved()">Approve</v-btn>
                </v-col>
            </v-card-text>
        </v-card>
        <v-snackbar v-model="notificationBar" top center :color="notificationColor" multi-line> {{ notificationText }}
            <v-btn color="amber" text @click="notificationBar = false"> Close </v-btn>
        </v-snackbar>
        <v-dialog v-model="TermBox" persistent max-width="980">
            <v-card>
                <v-card-title class="headline">Read Term and Condition Carefully.</v-card-title>
                <v-card-text v-html="orderRecord.termCondition"></v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-5" text @click="TermBox = false; isAccept=false">I Disagree.</v-btn>
                <v-btn color="green darken-1" text @click="TermBox = false; isAccept=true">I Agree.</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
         <span style="display:none;">{{checkAndFetch}}{{checkandfetch}}{{checkandfetchrecords}}</span>
    </v-container>
  
</template>

<script>
import { SERVER_API } from '../../API'
import {store} from '../../store'
    export default {
        created(){
            window.addEventListener('keyup', event => {
                if(event.which === 27){
                    this.Close();
                }
                if(event.which === 13){
                    this.Save();
                }
            })
        },
        //name:'purchaseFormA',
        props:['orderId'],
        computed:{
            checkAndFetch(){
               return this.fetchedbyid();
            },
            isDisabled(){
                return this.isAccept == false ? true : false;
            },
            checkandfetch(){
               return this.fetchparty();
            },
            checkandfetchrecords(){
                return this.fetchAddedParty();
            },
            isAdd(){
                return this.qty != '' && this.party !='' ? false : true;
            }
        },
        data(){
            return{
                loadingParty:false,
                loading:false,
                TermBox:false,
                isAccept:false,
                fRate:'',
                oRate:'',
                oQty:'',
                location:'',
                freight:'',

                orderRecord:'',
                store:store,
                // Notification Setting
                notificationColor: 'black',
                notificationBar: false,
                notificationText:'',

                //Add Party
                orderPartyData:[],
                partyData:[],
                qty:'',
                party:'',
                orderPartyHeader: [
                    {text: 'orderId', align: 'left', value: 'orderId',},
                    {text: 'Party', align: 'left', value: 'partyName',},
                    {text: 'Location', align: 'left', value: 'partyLocation',},
                    {text: 'QTY/Tons', align: 'left', value: 'qty',},
                ]
            }
        },
        methods:{
            async Send(){
                try{
                    const response = await this.$http.post(SERVER_API+'/order/sendemail/'+this.orderId);
                    this.$emit('Response', response.data);
                }catch(error){
                    alert(error);
                }
            },
            async fetchparty(){
                if(this.orderRecord.status == 'approved'){
                    try{
                        const Response = await this.$http.get(SERVER_API+'/broker/party/records');
                        this.partyData = Response.data.data;
                    }catch(error){
                        alert(error);
                    }
                }
            },
            async fetchAddedParty(){
                if(this.orderRecord.status == 'approved'){
                    try{
                        const Response = await this.$http.get(SERVER_API+'/order/party/records/'+this.orderId);
                        this.orderPartyData = Response.data.data;
                    }catch(error){
                        alert(error);
                    }
                }
            },
            async addParty(){
                this.loadingParty = true;
                const response = await this.$http.post(SERVER_API+'/order/party/create',{
                    qty:this.qty,
                    party:this.party,
                    order:this.orderId
                });
                if(response.data.action == true){
                    this.notificationColor = 'black';
                    this.notificationBar = true;
                    this.notificationText = response.data.message;
                }else{
                    this.notificationColor = 'red';
                    this.notificationBar = true;
                    this.notificationText = response.data.message;
                }
                this.loadingParty = false;
                //alert(Response.data.message);
                this.fetchAddedParty();
                this.qty = '',
                this.party =''
            },
            async fetchedbyid(){
                if(this.orderId != ''){
                    const Response = await this.$http.get(SERVER_API+'/order/purchaseformc/fetchbyid/'+this.orderId);
                    this.orderRecord = Response.data.data;
                    this.fRate = Response.data.data.fRate;
                    this.oRate = Response.data.data.oRate;
                    this.oQty = Response.data.data.oQty;
                    this.location = Response.data.data.location;
                    this.freight = Response.data.data.freight;
                }
            },
            Close(){
                this.$emit('Close', false);
            },
            async Approved(){
                try{
                    this.loading = true;
                const Response = await this.$http.post(SERVER_API+'/order/approve',{
                        id:this.orderId,
                    });
                    this.loading = false;
                    this.$emit('Response', Response.data);
                    this.Close();
                }catch(error){
                    alert(error);
                }
            },
            async Save(){
                try{
                    this.loading = true;
                    const Response = await this.$http.put(SERVER_API+'/customer/order/update/purchaseformc',{
                        id:this.orderId,
                        oRate: this.oRate,
                        oQty: this.oQty,
                        location: this.location,
                        freight: this.freight
                    });
                    this.loading = false;
                    this.$emit('Response', Response.data);
                    this.Close();
                }catch(error){
                    alert(error);
                }
            }
        }
    }
</script>
<style scoped>
.caption tr td{
    font-size: 13px;
    font-weight: bold;
}
.orderTableHeadding{
    background: #e0e0e0 !important;
    color:#000;
    font-weight: 900;
    text-transform: uppercase;
}
</style>